// @flow

export { InputMexicanPhoneNumber } from './input-mexican-phone-number';
export { InputMexicanZipcode } from './input-mexican-zipcode';
